// extracted by mini-css-extract-plugin
export default {"mCard":"Yw-z","image":"Zw-z","imageNoBackground":"_w-z","fullWidth":"ax-z"};